import type { Appearance } from '@stripe/stripe-js';
import { Color } from '../../../config/Color';
import { createAppearance } from '../Checkout';

const FIELD_BACKGROUND = 'rgba(0, 0, 0, 0.2)';
const FIELD_BORDER = '1px solid rgba(255, 255, 255, 0.15)';

// No dark panel around the fields, so they sit straight on the page.
const NO_PANEL = {
  backgroundColor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  padding: '0',
};

/** Stripe's card fields for Combo: Nerva's theme, but soft fields on the page, not one dark block. */
export function comboStripeAppearance(fontFamily: string): Appearance {
  return {
    ...createAppearance(true, fontFamily),
    rules: {
      '.Block': NO_PANEL,
      '.AccordionItem': NO_PANEL,
      '.Tab': { backgroundColor: FIELD_BACKGROUND, border: FIELD_BORDER, boxShadow: 'none' },
      '.Tab--selected': { border: '1.5px solid #FFFFFF', boxShadow: 'none' },
      '.Input': {
        backgroundColor: FIELD_BACKGROUND,
        border: FIELD_BORDER,
        padding: '16px',
        boxShadow: 'none',
      },
      '.Input:focus': { border: '1.5px solid #FFFFFF', boxShadow: 'none' },
      '.Input--invalid': { border: `1px solid ${Color.state.error}`, boxShadow: 'none' },
      '.Label': { fontSize: '14px', fontWeight: '500', color: '#FFFFFF', marginTop: '8px' },
    },
  };
}
